import { render, staticRenderFns } from "./FacetItemColor.vue?vue&type=template&id=c0a80e08&"
import script from "./FacetItemColor.vue?vue&type=script&lang=js&"
export * from "./FacetItemColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports